import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { employeereportDetails } from "../../../core/data/json/employeereportDetails";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  fetchAllemployeeReport,
  fetchAllemployeeNumberBymonth,
} from "../../../core/data/redux/reports/employee_report/employeereport.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { fetchAllDesignations } from "../../../core/data/redux/designation/designationAction";
import { fetchEmployeeAnalytics } from "../../../core/data/redux/employee/employeeAction";
import {
  fetchAllOffboardingReport,
  fetchAllOffboardingReportCount,
  fetchAllOffboardingReportCountMonthly,
} from "../../../core/data/redux/reports/offboarding_report/offboarding.Action";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";

interface OffboardingProps {
  showOnlyTable?: boolean;
}

const OffboardingReport: React.FC<OffboardingProps> = ({ showOnlyTable}) => {
  const { EmployeeAnalytics } = useSelector((state: any) => state.employee);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [monthcount, setMonthcount] = useState<any[] | null>(null);
  const [monthlyCounts, setMonthlyCounts] = useState<number[]>(
    new Array(12).fill(0)
  );
  const { departments } = useSelector((state: any) => state.department);
  const { designations } = useSelector((state: any) => state.designation);
  const [employeereportDetail, setemployeereportDetail] = useState<any>(null);
  const [employee_count, setemployee_count] = useState<any[] | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [
    dispatch,
    employeereportDetail,
    selectedStatus,
    selectedSort,
    filteredEmployees,
  ]);

  useEffect(() => {
    dispatch(fetchAllOffboardingReport(selectedYear)).then((res) => {
      setemployeereportDetail(res.payload.data);
    });
    dispatch(fetchAllOffboardingReportCount(selectedYear)).then((res) => {
      setemployee_count(res.payload.data);
    });
    dispatch(fetchAllOffboardingReportCountMonthly(selectedYear)).then(
      (res) => {
        setMonthlyCounts(res.payload.data);
      }
    );
  }, []);

  const data = employeereportDetail ? employeereportDetail : [];
  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, selectedStatus, employeereportDetail, selectedSort]);

  const columns = [
    {
      title: "Emp ID",
      dataIndex: "EmployeeNumber",
      render: (text: string, record: any) => (
        <Link to={all_routes.employeedetails}>Emp-{record.EmployeeNumber}</Link>
      ),
      sorter: (a: any, b: any) =>
        a.EmployeeNumber.localeCompare(b.EmployeeNumber),
    },
    {
      title: "Name",
      dataIndex: "EmployeeName",
      render: (text: string) => <p className="text-dark mb-0">{text}</p>,
      sorter: (a: any, b: any) => a.EmployeeName.localeCompare(b.EmployeeName),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => (a.Email || "").localeCompare(b.Email || ""),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: any, b: any) => (a.Phone || "").localeCompare(b.Phone || ""),
    },
    {
      title: "Department",
      dataIndex: "DepartmentName",
      sorter: (a: any, b: any) =>
        a.DepartmentName.localeCompare(b.DepartmentName),
    },
    {
      title: "OffBoarding Date",
      dataIndex: "SeparationDate",
      render: (text: string) => new Date(text).toLocaleDateString(),
      sorter: (a: any, b: any) =>
        new Date(a.SeparationDate).getTime() -
        new Date(b.SeparationDate).getTime(),
    },
    {
      title: "Type",
      dataIndex: "SeparationType",
      render: (text: string) => (
        <span
          className={`badge d-inline-flex align-items-center badge-xs ${
            text === "Termination" ? "badge-danger" : "badge-warning"
          }`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.SeparationType.localeCompare(b.SeparationType),
    },
  ];

  useEffect(() => {
    const updatedMonthlyCounts = new Array(12).fill(0);

    if (monthlyCounts && Array.isArray(monthlyCounts)) {
      monthlyCounts.forEach((item: any) => {
        const monthIndex = item.month - 1;
        updatedMonthlyCounts[monthIndex] = item.employee_count;
      });
    }

    const maxValue = Math.max(...updatedMonthlyCounts);
    const yAxisMax = Math.ceil(maxValue / 10) * 10 || 10;

    setEmployeechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: updatedMonthlyCounts,
        },
      ],
      yaxis: {
        ...prev.yaxis,
        max: yAxisMax,
        tickAmount: 5,
        labels: {
          offsetX: -15,
          formatter: (val: number) => val,
        },
      },
    }));
  }, [monthlyCounts]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllOffboardingReport(selectedYear)).then((res) => {
        setemployeereportDetail(res.payload.data);
      });
      dispatch(fetchAllOffboardingReportCount(selectedYear)).then((res) => {
        setemployee_count(res.payload.data);
      });
      dispatch(fetchAllOffboardingReportCountMonthly(selectedYear)).then(
        (res) => {
          setMonthlyCounts(res.payload.data);
        }
      );
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const [employeechart, setEmployeechart] = useState<any>({
    series: [
      {
        name: "Offboarding Employees",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "bar",
      height: 180,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    colors: ["#03C95A", "#E8E9EA"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: function (val: string) {
          return val + " Employee";
        },
      },
    },
  });

  if (showOnlyTable) {
  return (
     <Table
      key={tableKey}
      dataSource={filteredData}
      columns={columns}
      Selection={true}
    />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">OffBoarding Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    OffBoarding Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "OffBoarding_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() =>
                          exportToExcel(data, "OffBoarding_report")
                        }
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-icon.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Total Offboarding
                          </p>
                          <h5>
                            {employee_count && employee_count.length > 0
                              ? employee_count[0]?.TotalSeparated ?? 0
                              : 0}
                          </h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-success.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Resiged Employees
                          </p>
                          <h5>
                            {employee_count
                              ? employee_count?.[0].TotalResigned
                              : 0}
                          </h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-info.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Terminated Employees
                          </p>
                          <h5>
                            {employee_count
                              ? employee_count?.[0].TotalTerminated
                              : 0}
                          </h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="overflow-hidden d-flex mb-2 align-items-center">
                        <span className="me-2">
                          <ImageWithBasePath
                            src="assets/img/reports-img/employee-report-danger.svg"
                            alt="Img"
                            className="img-fluid"
                          />
                        </span>
                        <div>
                          <p className="fs-14 fw-normal mb-1 text-truncate">
                            Active Employee
                          </p>
                          <h5>
                            {employee_count
                              ? employee_count?.[0].TotalActiveEmployees
                              : 0}
                          </h5>
                        </div>
                      </div>
                      {/* <div>
                        <p className="fs-12 fw-normal d-flex align-items-center text-truncate ">
                          <span className="text-success fs-12 d-flex align-items-center me-1">
                            <i className="ti ti-arrow-wave-right-up me-1" />
                            +20.01%
                          </span>
                          from last week
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center row-gap-2">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-bar text-danger" />
                      </span>
                      <h5>Employee </h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center me-3 mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Employees Offboard
                      </p>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="employee-reports"
                    options={employeechart}
                    series={employeechart.series}
                    type="bar"
                    height={180}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employees List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default OffboardingReport;
